<template>
  <div class="chart-box">
    <div ref="wrapper"></div>
  </div>
</template>
<script>
  import { markRaw } from 'vue'
  import * as echarts from 'echarts'
  import { throttle } from '@/utils'
  export default {
    props: {
      wordChart: {
        type: Array,
        default: () => [],
      },
      wordData: {
        type: Array,
        default: () => [],
      },
      wordTitle: {
        type: String,
        default: '',
      },

      wordNameX: {
        type: String,
        default: '',
      },
      wordNameY: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        myChart: null,
        option: {
          title: {
            text: this.wordTitle,
            left: 'center',
          },

          color: ['#5379ad'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: '{b}<br/>{a}: {c}',
          },
          grid: {
            left: '4%',
            right: '5%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            data: this.wordChart,
            name: this.wordNameX,
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              fontWeight: 600,
            },
          },

          yAxis: {
            type: 'value',
            min: 0,
            name: this.wordNameY,
            axisLabel: {
              formatter: '{value}',
              fontWeight: 600,
            },
            axisLine: {
              show: true,
            },
          },

          series: {
            name: 'value',
            type: 'bar',
            barWidth: '40%',
            data: this.wordData,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#80a9fb' },
                { offset: 0.5, color: '#5d8ceb' },
                { offset: 1, color: '#46649f' },
              ]),
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#46649f' },
                { offset: 0.7, color: '#5d8ceb' },
                { offset: 1, color: '#80a9fb' },
              ]),
            },
          },
        },
      }
    },

    watch: {
      wordData: {
        handler() {
          setTimeout(() => {
            this.drawLine()
          }, 50)
        },
        deep: true,
      },
    },

    mounted() {
      this.myChart = markRaw(echarts.init(this.$refs.wrapper))

      this.drawLine()
      window.addEventListener('resize', throttle(this.resize, 500))
    },
    unmounted() {
      window.removeEventListener('resize', this.resize)
    },
    methods: {
      drawLine() {
        let option = { ...this.option }
        option.xAxis.data = this.wordChart
        option.xAxis.name = this.wordNameX
        option.yAxis.name = this.wordNameY
        option.series.data = this.wordData
        option.title.text = this.wordTitle
        this.myChart.setOption(option)
      },
      resize() {
        this.myChart.resize()
      },
    },
  }
</script>
<style lang="less" scoped>
  .chart-box {
    & > div {
      width: 100%;
      height: 100%;
    }
  }
</style>
